import { ActiveReservationFees } from 'selectors/activeReservationSelector';
import { DisplayMoney } from '@tock/money';
import { FunctionComponent } from 'react';
import { IconCash, IconInvoice } from '@tock/icons';
import { IconFee, IconMoney } from 'ui/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { PriceRange } from 'components/business/PriceRange';
import { Typography, TypographyProps } from 'omakase';
import { consumer, core } from '@tock/coretypes';

export interface ReservationPriceDetailProps {
  ticketTypeDefaultPrice?: number;
  ticketTypeDescriptiveVariety?: core.DescriptiveVariety;
  ticketTypeFees: ActiveReservationFees;
  ticketTypeVariety?: core.TicketType.Variety;
  typographyVariant?: TypographyProps['variant'];
  ticketPriceInformation?: core.ITicketPriceInformation;
}

export const ReservationPriceDetail: FunctionComponent<ReservationPriceDetailProps> = ({
  ticketTypeDefaultPrice,
  ticketTypeDescriptiveVariety,
  ticketTypeFees,
  ticketTypeVariety,
  typographyVariant,
  ticketPriceInformation,
}) => {
  // A bit of a dodge, but:
  const offeredPrice = {
    pricePerPerson: {
      minCents: ticketPriceInformation?.amountCents || ticketTypeDefaultPrice,
      maxCents: ticketPriceInformation?.amountCents || ticketTypeDefaultPrice,
    },
    supplements: [],
  } as consumer.IOfferedPriceSummary;

  // core.TicketTypeVariety is _almost_ assignable to consumer.Offering.Type;
  // we apply this minor patch.
  if (ticketTypeVariety === 'FULL') {
    ticketTypeVariety = undefined;
  }

  return (
    <>
      {!!ticketTypeDefaultPrice && (
        <li key="defaultPrice">
          <IconMigrationUtil legacyIcon={<IconMoney />} newIcon={<IconCash />} />
          <Typography variant={typographyVariant} color="fgDefault">
            <span>
              <PriceRange
                price={offeredPrice}
                type={ticketTypeVariety}
                descriptiveVariety={ticketTypeDescriptiveVariety}
                priceDistribution={ticketPriceInformation?.priceDistribution}
              />
            </span>
          </Typography>
        </li>
      )}
      {ticketTypeFees.map(({ name, priceCents }, index) => (
        <li key={`fee${index}`}>
          <IconMigrationUtil legacyIcon={<IconFee />} newIcon={<IconInvoice />} />
          <Typography variant={typographyVariant} color="fgDefault">
            <span>
              <DisplayMoney amount={priceCents} roundIfWholeNumber /> {name}
            </span>
          </Typography>
        </li>
      ))}
    </>
  );
};
